export const setViewportFullHeight = (): void => {
  function calculateInnerHeightAndSetStyle() {
    const height = window.visualViewport?.height ?? window.innerHeight
    document.documentElement.style.setProperty('--full-height', `${height}px`)
  }

  calculateInnerHeightAndSetStyle()

  window.addEventListener('load', calculateInnerHeightAndSetStyle)
  window.addEventListener('resize', calculateInnerHeightAndSetStyle)
  window.visualViewport?.addEventListener(
    'resize',
    calculateInnerHeightAndSetStyle,
  )
}
